/**
 * Tone of the confirm action — drives both the icon (in `ConfirmDialog`'s
 * default header glyph) and the variant of the confirm `Button`.
 *
 *   - `danger`  destructive irreversible action (delete, drop, revoke).
 *               Confirm button paints in the danger variant.
 *   - `caution` reversible-but-careful action (overwrite, archive, end
 *               session). Confirm button paints in the filled variant
 *               with a caution-tinted icon.
 *   - `info`    purely informational ack (acknowledge an EULA, ack a
 *               long-running job). Confirm button is the standard primary.
 */
export const CONFIRM_DIALOG_TONE_DANGER = 'danger';
export const CONFIRM_DIALOG_TONE_CAUTION = 'caution';
export const CONFIRM_DIALOG_TONE_INFO = 'info';

export type ConfirmDialogTone =
  | typeof CONFIRM_DIALOG_TONE_DANGER
  | typeof CONFIRM_DIALOG_TONE_CAUTION
  | typeof CONFIRM_DIALOG_TONE_INFO;
